import { IProduct, Product } from './product';

export interface IExamAddOn extends IProduct {
  personId: number;
  applicationId: number;
  serviceCodeId: number;
  price: number;
}

export class ExamAddOn extends Product implements IExamAddOn {
  personId = null;
  applicationId = null;
  serviceCodeId = null;
  price = null;
}
